import type { ReactNode } from 'react';

export const symbol_share_reviews: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M580.09-370q28.91 0 49.41-20.59 20.5-20.59 20.5-49.5t-20.56-49.41Q608.88-510 580-510q-14.64 0-27.82 5.5T529-488l-120-60q1-3 1-6v-12q0-3-1-6l120-60q10 11 23.18 16.5T580-610q28.88 0 49.44-20.59t20.56-49.5q0-28.91-20.59-49.41-20.59-20.5-49.5-20.5t-49.41 20.56Q510-708.88 510-680v6q0 3 1 6l-120 60q-10-11-23.18-16.5T340-630q-28.87 0-49.44 20.59Q270-588.82 270-559.91t20.56 49.41Q311.13-490 340-490q14.64 0 27.82-5.5T391-512l120 60q-1 3-1 6v6q0 28.87 20.59 49.44Q551.18-370 580.09-370ZM240-240 131-131q-14 14-32.5 6.34Q80-132.31 80-152v-668q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H240Zm-26-60h606v-520H140v600l74-80Zm-74 0v-520 520Z"
		/>
	</svg>
);
